(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
// Adresses client : présélection du pays enregistré + confirmation de suppression.
(function () {
  if (window.__lvAddressesInit) return;
  window.__lvAddressesInit = true;
  var initSelects = function () {
    document.querySelectorAll('select[data-default]').forEach(function (select) {
      if (select.dataset.default) select.value = select.dataset.default;
    });
  };
  if (document.readyState !== 'loading') initSelects();
  else document.addEventListener('DOMContentLoaded', initSelects);
  document.addEventListener('submit', function (e) {
    var btn = e.submitter || (e.target && e.target.querySelector('[data-confirm]'));
    var msg = btn && btn.dataset && btn.dataset.confirm;
    if (msg && !window.confirm(msg)) e.preventDefault();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    if (window.__lvMainCollectionInit) return;
    window.__lvMainCollectionInit = true;

    let filtersTimer = null;

    document.addEventListener('change', (event) => {
      const sortSelect = event.target.closest('[data-sort-select]');
      if (sortSelect) {
        if (sortSelect.form) sortSelect.form.submit();
        return;
      }

      const filtersForm = event.target.closest('[data-filters-form]');
      if (!filtersForm) return;

      clearTimeout(filtersTimer);
      filtersTimer = setTimeout(() => filtersForm.submit(), 400);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-promo"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__lvPopupPromo) return;
  window.__lvPopupPromo = true;

  const storageKey = (el) => 'lyvora:popup:' + el.id;
  const stamp = (el) => {
    try {
      localStorage.setItem(storageKey(el), String(Date.now()));
    } catch (e) {
      /* stockage indisponible : on n'insiste pas */
    }
  };

  const initPopup = (el) => {
    if (!el || el.__lvPopupInit) return;
    el.__lvPopupInit = true;

    el.addEventListener('lyvora:close', () => stamp(el));

    if (el.hasAttribute('data-design-mode')) return;
    if (el.hasAttribute('data-no-mobile') && window.matchMedia('(max-width: 749px)').matches) return;

    const days = parseFloat(el.dataset.frequency) || 7;
    let last = 0;
    try {
      last = parseInt(localStorage.getItem(storageKey(el)), 10) || 0;
    } catch (e) {
      last = 0;
    }
    if (Date.now() - last < days * 86400000) return;

    const delay = (parseFloat(el.dataset.delay) || 0) * 1000;
    setTimeout(() => {
      if (document.body.classList.contains('lv-locked')) return;
      if (typeof el.open === 'function' && !el.isOpen) el.open();
    }, delay);
  };

  const initAll = () => {
    document.querySelectorAll('.lv-popup-promo[data-enabled]').forEach(initPopup);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Inscription newsletter envoyée depuis le popup : on horodate aussi.
  document.addEventListener('submit', (e) => {
    const el = e.target.closest('.lv-popup-promo');
    if (el) stamp(el);
  });

  // Copie du code promo (délégué, idempotent).
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-copy-code]');
    if (!btn) return;
    const code = btn.getAttribute('data-copy-code');
    if (!code || !navigator.clipboard) return;
    navigator.clipboard
      .writeText(code)
      .then(() => {
        const label = btn.querySelector('[data-copy-label]') || btn;
        if (!btn.__lvCopyText) btn.__lvCopyText = label.textContent;
        label.textContent = btn.getAttribute('data-copied-text') || 'Copié !';
        clearTimeout(btn.__lvCopyTimer);
        btn.__lvCopyTimer = setTimeout(() => {
          label.textContent = btn.__lvCopyText;
          btn.__lvCopyText = null;
        }, 2000);
      })
      .catch(() => {});
  });

  // Éditeur de thème : le popup s'ouvre quand sa section est sélectionnée.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:select', (e) => {
      const el = e.target.querySelector('.lv-popup-promo');
      if (el && typeof el.open === 'function') el.open();
    });
    document.addEventListener('shopify:section:deselect', (e) => {
      const el = e.target.querySelector('.lv-popup-promo');
      if (el && typeof el.close === 'function') el.close();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
// Recommandations produit : charge la section via la Section Rendering API.
(function () {
  function init(root) {
    root.querySelectorAll('.lv-product-recommendations[data-url]:not([data-loaded])').forEach(function (el) {
      el.setAttribute('data-loaded', 'true');
      var observer = new IntersectionObserver(
        function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          observer.disconnect();
          fetch(el.dataset.url)
            .then(function (res) { return res.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var fresh = doc.querySelector('.lv-product-recommendations');
              if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
            })
            .catch(function () {});
        },
        { rootMargin: '400px 0px' }
      );
      observer.observe(el);
    });
  }
  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
